import store from './store';

export default store;
export * from './selectors';
